/* eslint-disable */
const apiConfig = {
  restServiceDomain: VARS.API_DOMAIN,
  isFaqVisible: VARS.FAQ_VISIBLE,
  enableNewPaymentScreen: false,
  cellcaptiveId: VARS.CELLCAPTIVE_ID,
};

export default apiConfig;



// WEBPACK FOOTER //
// ./app/utils/apiConfig.js